import CloseIcon from '@mui/icons-material/Close'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton
} from '@mui/material'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import './HowIsWasDoneModal.scss'

interface HowIsWasDoneModalProps {
  open: boolean
  onClose: () => void
  title?: string
  children?: React.ReactNode
}

const HowIsWasDoneModal = ({
  open,
  onClose,
  title,
  children,
}: HowIsWasDoneModalProps) => {
  const { t }: any = useTranslation()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="how-is-was-done-title"
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle
        className="how-is-was-done-modal-title"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >

        <span className="how-is-was-done-modal-title-text">
          {title || t('investigation.title')}
        </span>

        <IconButton className="close-modal" onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className="how-it-was-done-content" dividers>
        <h2 style={{ margin: 0 }}>{t('investigation.modalTextTile')}</h2>
        {children || (
          <Trans i18nKey="investigation.modalText">
            <span />
          </Trans>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default HowIsWasDoneModal
